<template>
  <div class="a11y-modal">
    <div class="title">
      <h2>Credits</h2>
      <button class="close" @click="closeModal">×</button>
    </div>

    <div class="content">
      <div class="row">
        <div class="col-12 mb-2">
          <h3>What are credits?</h3>
          <p>
            Credits are how your users pay for BetterMynd sessions. 
            Session credits are spent when a session request is accepted by a counselor.
            Workshop credits are spent when a user reserves a spot in an upcoming workshop.
          </p>
          <h3>How many credits can my users spend?</h3>
          <p>
            You can give your users an <b>allowance</b> of credits.
            Once the user has spent all the credits you have allowed them
            they cannot spend any more, and must self-pay.
            To view or modify a user's allowance, visit the users tab.
          </p>
          <h3>What do the dates in this report represent?</h3>
          <p>
            Entry dates are when the credit transaction occurred. 
            For details based on <b>sessions</b> and their outcomes, visit the sessions tab.
          </p>
          <h3>What do the different buckets in the report mean?</h3>
          <ul>
            <li>
              <b>Adds:</b> 
              Your purchases of additional credits
            </li>
            <li>
              <b>Successful:</b> 
              Spent credits where both the user and counselor attended the session.
            </li>
            <li>
              <b>Upcoming:</b> 
              Spent credits for sessions that have not yet occurred.
            </li>
            <li>
              <b>Late Cancel:</b> 
              Spent credits for sessions users cancel within 24 hours of the session start.
            </li>
            <li>
              <b>No Show:</b>
              Spent credits for sessions the user or counselor did not attend. 
              Any session not attended by a counselor will be refunded.
            </li>
            <li>
              <b>Difference:</b>
              The sum total of the reporting buckets for the given date range.
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="actions">
      <button type="button" @click="closeModal">Close</button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'DocumentationModal',

  methods: {
    closeModal() {
      this.$modal.close();
    }
  }
});
</script>

<style lang="scss" scoped>
.a11y-modal {
  max-height: 600px;
}

.title {
  border-bottom: none;
}

.content {
  padding-top: 0;
}

h3 {
  color: #303030;
  font-family: $sans;
  font-size: 16px;
  margin: 20px 0 4px 0;
}
</style>
